// search filter constants

export const REQUEST_COUNTS = 'counts';
export const REQUEST_HOUSES = 'houses';
